import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

// Hook
import { useAuth } from "../hooks/useAuth";

// Components
import LevelCard from "../components/LevelCard";
import MainView from "../components/MainView";

export default function GameMenu() {
  const location = useLocation();
  const navigate = useNavigate();

  const { auth } = useAuth();

  const { user } = auth;
  const { game } = location.state || {};

  if (game === undefined || game === null) {
    return <Navigate to="/games" replace />;
  }

  return (
    <MainView>
      <div className="mt-5 px-[5vw] 2xl:px-[15vw]">
        <div className="mb-10">
          <div id="gameDescBox" className="mx-auto sm:max-w-full xl:max-w-5xl">
            <div className="flex flex-col sm:flex-row items-center sm:justify-center sm:gap-5">
              <div className="mt-5 first:mt-0 sm:mt-0 h-56 sm:h-36 w-56 sm:w-36">
                <img
                  src={require(`../assets/core/img/${game.game_id}.png`)}
                  alt=""
                  className="w-full h-full"
                />
              </div>

              <div className="mt-5 first:mt-0 sm:mt-0 sm:w-[75%]">
                <div className="flex flex-col items-center justify-center sm:items-start">
                  <div>
                    <p className="font-retro-sabo uppercase text-center leading-none text-4xl">
                      {game.game_name}
                    </p>
                  </div>
                  <div className="mt-2 lg:w-4/5">
                    <p className="font-retro-rounded text-xl text-center sm:text-left">
                      {game.game_desc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 px-[5vw] 2xl:px-[15vw]">
        <div className="mb-3">
          <div
            id="levelCardBox"
            className="mx-auto max-w-[200px] sm:max-w-full xl:max-w-5xl"
          >
            <div className="grid grid-cols-1 sm:grid-cols-5 sm:gap-5">
              {[...Array(game.game_level)].map((_, i) => {
                return (
                  <div key={i} className="mt-5 sm:mt-0 first:mt-0">
                    <LevelCard
                      level={i + 1}
                      locked={user.level[game.game_id] >= i + 1 ? false : true}
                      onClick={() => {
                        navigate(`/g/${game.game_id}/play`, {
                          state: { game, level: i + 1, option: "play" },
                          replace: true,
                        });
                      }}
                    />
                  </div>
                );
              })}
            </div>

            <div className="mb-6 mt-3">
              <p
                className="font-retro-rounded font-medium uppercase leading-none text-xl cursor-pointer"
                onClick={() => {
                  navigate(`/g/${game.game_id}/play`, {
                    state: { game, level: 1, option: "tutorial" },
                    replace: true,
                  });
                }}
              >
                Tutorial
              </p>
            </div>
          </div>
        </div>
      </div>
    </MainView>
  );
}
